import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Chips } from '@cian/ui-kit';

import { hasDecorationDescriptors } from '../../constants/descriptors';
import { isDescriptorActive } from '../../utils/filters';
import { IApplicationState } from '../../types/redux';
import { TTypedThunkDispatch } from '../../types/thunk';
import { getOffersCount } from '../../actions/offersData';
import { updateTags } from '../../actions/filterTags';

export const HasDecoration: React.FC = React.memo(() => {
  const dispatch = useDispatch<TTypedThunkDispatch>();
  const jsonQuery = useSelector((state: IApplicationState) => state.jsonQuery);

  const options = React.useMemo(
    () =>
      hasDecorationDescriptors.map(({ state, label }) => ({
        label,
        value: state,
      })),
    [],
  );

  const activeDescriptors = React.useMemo(
    () => hasDecorationDescriptors.filter(descriptor => isDescriptorActive(descriptor)(jsonQuery)),
    [jsonQuery],
  );

  const currentValues = React.useMemo(() => activeDescriptors.map(d => d.state), [activeDescriptors]);

  const handleChipClick = React.useCallback(
    (value: string) => {
      const descriptor = hasDecorationDescriptors.find(d => d.state === value);

      if (descriptor) {
        dispatch({
          type: `${descriptor.name}/${descriptor.state}`,
          value,
        });
        dispatch(updateTags());
        dispatch(getOffersCount());
      }
    },
    [dispatch],
  );

  return <Chips options={options} size="M" value={currentValues} selectType="multiple" onChipClick={handleChipClick} />;
});

HasDecoration.displayName = 'HasDecoration';
